import { render } from "./TokoList.vue?vue&type=template&id=64d598aa&scoped=true"
import script from "./TokoList.vue?vue&type=script&lang=js"
export * from "./TokoList.vue?vue&type=script&lang=js"

import "./TokoList.vue?vue&type=style&index=0&id=64d598aa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-64d598aa"

export default script